import {
  Avatar,
  Card,
  CopyToClipboard,
  NeutralTag,
  Text,
} from "@certn/cascadia-react";
import { css } from "@emotion/css";
import { useFlags } from "launchdarkly-react-client-sdk";
import { useLocation, useNavigate } from "react-router-dom";

import { ActionsDropdown } from "../components/ActionsDropdown";

interface Props {
  name: string | undefined;
  email: string | undefined;
  id: string;
  groups: string;
  tags: string[];
}
export function TableDataCard(props: Props) {
  const { name, email, id, tags } = props;
  const navigate = useNavigate();
  const location = useLocation();
  const { clientPortalCaseTags } = useFlags();

  return (
    <Card>
      <div
        className={styles.container}
        role="presentation"
        onClick={() => {
          navigate(`/profiles/${id}`, {
            state: {
              last: { href: `${location.pathname}${location.search}` },
            },
          });
        }}
        data-testid="sm-user-selectable-container"
      >
        <div className={styles.mainContent}>
          <div className={styles.profileDetailsContainer}>
            <Avatar name={name || email} />
            <div className={styles.profileDetails}>
              <Text style="global/heading-medium" testID="sm-profile-name">
                {name || "--"}
              </Text>
              <Text color="text-weak" testID="sm-profile-email">
                {email ? (
                  <CopyToClipboard text={email} testID="copyable-email" />
                ) : (
                  "--"
                )}
              </Text>
            </div>
          </div>
          <ActionsDropdown id={id} />
        </div>

        {clientPortalCaseTags && tags && (
          <div className={styles.tags}>
            {tags.map((tag, i) => {
              return (
                <NeutralTag testID="sm-profile-tags" type="subtle" key={i}>
                  {tag}
                </NeutralTag>
              );
            })}
          </div>
        )}
      </div>
    </Card>
  );
}

const styles = {
  container: css({
    padding: "var(--space-4)",
    display: "flex",
    flexDirection: "column",
    gap: "var(--space-4)",
    borderRadius: "var(--border-radius-3)",
    cursor: "pointer",
  }),
  mainContent: css({
    display: "flex",
    justifyContent: "space-between",
  }),
  profileDetailsContainer: css({
    display: "flex",
    alignItems: "center",
    gap: 10,
  }),
  profileDetails: css({
    display: "flex",
    flexDirection: "column",
  }),
  tags: css({
    display: "flex",
    gap: "var(--space-2)",
    flexWrap: "wrap",
  }),
};
